import React, { useState } from 'react';
import { Box, Stack, Typography, Container } from '@mui/material';
import PropTypes from 'prop-types';
import CustomerTable from './CustomerTable';
import { is360PayStaff } from '../../utils/roles';

import ReportingContainer from '../Reporting/ReportingContainer';
import SideNav from './SideNav';

import CustomerIcon from '@mui/icons-material/Person';
import ReportsIcon from '@mui/icons-material/Description';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} className="wrapper-tabspanel">
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function SelectCustomer() {
  const [value, setValue] = useState(0);

  const tabData = [
    { label: 'Select a customer', id: 'select-customer', icon: <CustomerIcon /> },
    ...(is360PayStaff() ? [] : [{ label: 'Reports', id: 'reports', icon: <ReportsIcon /> }]),
  ];

  return (
    <Container maxWidth="xl" sx={{ px: 4, mt: 4, mb: 4 }}>
      <Stack direction="row" gap={2} className="stepper-wrapper-tabs select-customer-comp">
        <div className="rowWrapper">
          <SideNav heading="Settings" tabs={tabData} setValue={setValue} value={value} />

          <TabPanel index={0} value={value}>
            <CustomerTable />
          </TabPanel>
          <TabPanel index={1} value={value}>
            <ReportingContainer />
          </TabPanel>
        </div>
      </Stack>
    </Container>
  );
}

TabPanel.propTypes = {
  children: PropTypes.object,
  value: PropTypes.number,
  index: PropTypes.number,
};
